import React, { useEffect, useState } from 'react';
import axios from '../api/axiosInstance';
import { useNavigate } from 'react-router-dom';

// Emoji icon mapping based on category name
const emojiMap = {
  'Food': '1f37d',
  'Apparel & Accessories': '1f455',
  'Home Appliances': '1f50c',
  'Computer & Office': '1f4bb',
  'Home Improvement': '1f6e0',
  'Home & Garden': '1fab4',
  'Sports & Entertainment': '1f3c0',
  'Office & School Supplies': '1f4dd',
  'Beauty & Health': '1f485',
  'Toys & Hobbies': '1f3ae',
  'Default': '1f6d2', // Shopping cart
};

// Return emoji image URL
const getEmojiImage = (categoryName) => {
  const code = emojiMap[categoryName] || emojiMap['Default'];
  return `https://cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/72x72/${code}.png`;
};

const TopCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get('/categories/hierarchy/')
      .then((res) => {
        const top = res?.data?.hierarchy?.slice(0, 8) || [];
        setCategories(top);
      })
      .catch((err) => {
        console.error('Failed to fetch categories:', err);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleClick = (categoryId, categoryName) => {
    navigate(`/products?category=${categoryId}&search=${encodeURIComponent(categoryName)}`);
  };

  return (
    <section id="categories" className="py-16 bg-white px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-800 mb-10">
          Top Categories
        </h2>

        {loading ? (
          <div className="flex justify-center items-center py-20">
            <svg className="animate-spin h-10 w-10 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
            </svg>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-6">
              {categories.map((cat, index) => (
                <div
                  key={index}
                  onClick={() => handleClick(cat.category_id, cat.category_name)}
                  className="bg-white cursor-pointer rounded-xl shadow-md hover:shadow-lg transition duration-300 p-4 text-center transform hover:-translate-y-1"
                >
                  <img
                    src={getEmojiImage(cat.category_name)}
                    alt={cat.category_name}
                    className="w-20 h-20 mx-auto mb-4 transition-transform duration-300 hover:scale-110"
                  />
                  <h3 className="text-sm font-semibold text-gray-700">{cat.category_name}</h3>
                </div>
              ))}
            </div>

            {/* View More Categories Button */}
            <div className="mt-10 text-center">
              <button
                onClick={() => navigate('/products')}
                className="inline-block px-6 py-3 text-sm font-semibold text-white bg-green-600 hover:bg-green-700 transition rounded-md"
              >
                View More Categories
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default TopCategories;
